import React from 'react'
import MaterialSymbol from '../material-symbol'

const MailOutline = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="mail_outline" {...props} />
))

MailOutline.displayName = 'MailOutline'

export default MailOutline
